import {OrbitTheme} from '../../architecture/orbit-theme.interface';
import {makeTheme} from '../../make-theme';
import {IGeneralColors} from '../../architecture/sections/general-colors.interface';
import {makeCasino888FontsFamily} from './make-casino888-fonts-family';
import {Color} from './casino888-colors';
import {Casino888Icons} from './icons-registry';
import { ThemeName } from '../../architecture/theme-names';


/*$body-font-family: '888-DemiBold', verdana, sans-serif;
$body-font-size: 10px;
$body-font-size-smaller-screen: 8.5px;
$body-font-family-Thin: '888-Thin', verdana, sans-serif;
$body-font-family-Light: '888-Light', verdana, sans-serif;
$body-font-family-Regular: '888', verdana, sans-serif;
$body-font-family-Bold: '888-Bold', verdana, sans-serif;
$body-font-family-Medium: '888-Medium', verdana, sans-serif;
$body-font-family-Black: '888-Black', verdana, sans-serif;
$body-font-family-Ultra: '888-Ultra', verdana, sans-serif;
$body-font-family-Secondary: 'Oleo-Script-Regular', sans-serif;

// Lobster used here as a backup for the romanian regulation missing glyphs
$body-font-family-secondary-bkp: 'Lobster', sans-serif;
*/



const generalColors: IGeneralColors  = {
    brandPrimary: Color.turbo,    //$yellow,
    brandSecondary: Color.brandGreen,   //$brand-green
    bodyText: Color.white,
    bodyInfo: Color.grey,
    bodyBackground: Color.darkBlack,
    bodyBackgroundLight: Color.darkGrey,
    bodyHover: Color.darkBlack,
    buttonDark: Color.black,
    buttonLight: Color.white,
    buttonInfo: Color.grey,
    buttonWarning: Color.red,
    componentBackground: Color.lightBlack,
    componentTextInfo: Color.grey,
    componentTextLight: Color.white,
    headerBackground: Color.black,
    headerText: Color.brandGreen,
    modalDialogBorder: Color.grey,
    gameDescriptionText: Color.smokeGrey,
    intermediatePageGradientBackground: `linear-gradient(to bottom,  ${Color.transparent} 46%, ${Color.darkBlack} 100%)`,
    dividerBottomBorder: Color.slateGrey,
    dividerTopBorder: Color.softGrey,
    navBackground: Color.black,
    navBoxBackground: Color.lightBlack,
    navItemTextNormal: Color.grey,
    navItemTextHover: Color.white,
    navItemTextActive: Color.turbo,

    usefulLinkBackground: Color.lightBlack,
    usefulLinkTextNormal: Color.grey,
    usefulLinkTextHover: Color.white,

    arenaTitle: Color.white,
    filterSelected: Color.brandGreen,
    filterTop: Color.yellow,
    filterMiddle: Color.pear,
    filterBottom: Color.inchWorm,

    spinnerBackground: "#000000",

    arenaTitleTopDevider: Color.black,
    arenaTitleBottomDevider: Color.middleGrey,

    searchLinksBorder: Color.lightBlack,
    searchResultsBorder: Color.softGrey,

    userMenuSectionText: Color.grey,
    userMenuSectionBg: Color.lightBlack,
    userMenuTitleText: Color.grey,
    userMenuBalanceTitle: Color.white,
    userMenuBalanceColor: Color.turbo,
    userMenuBalanceBorder: Color.darkBlack,
    sideMenuLogoBackground: Color.brandGreen,
    verticalListBackground: Color.darkBlack,
  jackpotValueColor: Color.turbo
};

const Casino888Theme: OrbitTheme = makeTheme({
    themeName: ThemeName.Casino888,
    generalColors: generalColors,
    fonts: makeCasino888FontsFamily(),
    themeSpecificIcons: Casino888Icons
});

export default Casino888Theme;
